import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle, FiAlertCircle, FiInfo } = FiIcons;

const Layout = ({ admin, backendStatus, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const previewModules = ['/security','/deliverability','/otp-settings','/ai-assistant','/data-model'];
  const [toasts, setToasts] = useState([]);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  useEffect(() => {
    const handleToast = (event) => {
      const id = Date.now() + Math.random();
      setToasts(prev => [...prev, { id, ...event.detail }]);
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, 3500);
    };

    window.addEventListener('show-toast', handleToast);
    return () => window.removeEventListener('show-toast', handleToast);
  }, []);

  const toastStyle = (type) => {
    if (type === 'error') return 'bg-red-600 border-red-500';
    if (type === 'warning') return 'bg-amber-500 border-amber-400';
    if (type === 'info') return 'bg-blue-600 border-blue-500';
    return 'bg-emerald-600 border-emerald-500';
  };

  const toastIcon = (type) => {
    if (type === 'error' || type === 'warning') return FiAlertCircle;
    if (type === 'info') return FiInfo;
    return FiCheckCircle;
  };

  return (
    <div className="flex h-screen overflow-hidden bg-slate-50 font-sans">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <Topbar
          toggleSidebar={toggleSidebar}
          admin={admin}
          backendStatus={backendStatus}
          onLogout={onLogout}
        />

        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8 custom-scrollbar">
          <div className="max-w-7xl mx-auto pb-12">
            {backendStatus?.pocketbase === 'connected' && backendStatus?.gateway !== 'operational' && (
              <div className="mb-6 rounded-2xl border border-amber-200 bg-amber-50 p-4 flex items-start gap-3 text-amber-900">
                <SafeIcon icon={FiAlertCircle} className="mt-0.5 shrink-0" />
                <div>
                  <p className="text-sm font-black">PocketBase is online, but the BPA Mail Hub hook is unavailable.</p>
                  <p className="text-xs mt-1 leading-relaxed">
                    Install the Mail Hub hook on PocketHost and configure the required PocketHost environment secrets. Netlify serves the frontend only.
                  </p>
                </div>
              </div>
            )}
            {previewModules.includes(location.pathname) && <div role="status" className="mb-5 rounded-xl border border-amber-200 bg-amber-50 p-3 text-xs text-amber-900">Preview-only module: settings shown here are not fully connected to the PocketBase email engine. Do not rely on them for security, OTP or provider routing.</div>}
            <Outlet />
          </div>
        </main>
      </div>

      <div className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-[200] flex flex-col gap-3 pointer-events-none">
        {toasts.map(toast => (
          <div
            key={toast.id}
            className={`${toastStyle(toast.type)} border text-white px-5 py-3.5 rounded-2xl shadow-2xl flex items-center gap-3 animate-in slide-in-from-right-8 fade-in pointer-events-auto`}
          >
            <SafeIcon icon={toastIcon(toast.type)} className="text-xl" />
            <p className="text-sm font-bold tracking-wide">{toast.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Layout;